import './Text.css';



export function PoetryAndPerformance() {
  return (
    <div class="body">
              <div class="row" id="GalleryThree">
                 <div class="column">
<a href="/TooComfortably"><img alt="Grim Reynolds" src="TooComfortably.gif" href="/ASD.js" /></a>


    <h4><a href="/">Too Comfortably  &#40; Mix-tape &#41;</a> 
    , 2026
<br/>
Photographic Urban Development exploration, Mix-tape with original songs, Hand-drawn protest font.
                </h4>
</div>
              </div>


        <div class="row" id="GalleryThree">





                 <div class="column">
            <div >
               <a href="/WeatherBody"> <img alt="Weather Body" src="WeatherBody2.png"/></a>
            </div>
            <br/><h4>
                <a href="/WeatherBody">
   Weather Body
                </a>, 2025
               <br/>
               Poetry Anthology
                </h4>
        </div>

                <div class="column">
            <div>
                <a href="/WetCloud"><img alt="Wet Cloud" src="WetCloud.gif" href="/WetCloud.js" />
            </a></div>
<h4>
                <a href="/WetCloud">Wet Cloud</a>, 2025
                               <br/> 
 Animation,  <a href="Elearning With Water : A Collaboration Between Friedrich-Schiller-Universität Jena And Bauhaus-Universität Weimar. Toland, A., Rosenthal, C., Waffel, C., Albrecht, A., 2025. https://doi.org/10.22032/dbt.68115.">
               Published Essay, </a> and
Risograph Print
                <br/> Developed at Bauhaus-Universität Weimar



                </h4>
        </div>

    </div>
    </div>

  );
}
